import pwcLogo from "assets/images/companyLogos/PwC_logo_light_mode.png";
import pwcLogoWhite from "assets/images/companyLogos/PwC_logo_dark_mode.png";
import vismaLogo from "assets/images/companyLogos/visma-logo.png";
import vismaLogoWhite from "assets/images/companyLogos/visma-logo-white.png";

interface Partners {
  name: string;
  description: string;
  url: string;
  logo: string;
  whiteLogo: string;
}

// Record containing Bindeleddet NTNU's company partners.
// Follow pattern under if you are adding or changing partners.

export const partners: Record<string, Partners> = {
  PwC: {
    name: "PwC",
    description:
      "PwC er verdens største nettverk av rådgivere, revisorer og advokater. Vi leverer et bredt spekter av profesjonelle tjenester og er en av landets ledende leverandører innen rådgivning og revisjon. I Norge har vi nært 1500 ansatte, representert i et landsdekkende kontornettverk. Tjenestene som leveres fra rådgivningsenheten til PwC i Norge omfatter prosessforbedring, strategisk analyse, verdikjedeoptimalisering, IT-strategi og systemvalg, prosjekt- og endringsledelse, i tillegg til transaksjonsstøtte, M&A, verdsettinger og finansiell rådgivning.",
    url: "https://www.pwc.com/",
    logo: pwcLogo,
    whiteLogo: pwcLogoWhite,
  },
  Visma: {
    name: "Visma",
    description:
      "Visma er et ledende teknologikonsern med hovedkontor i Oslo. Vi eier over 150 selskaper i 28 land og betjener mer enn 2,5 millioner kunder i Europa og Latin-Amerika. Drevet av en unik kombinasjon av lokal kunnskap og global tyngde, leverer vi skybasert programvare som gjør det enklere og mer effektivt å drive virksomhet i både privat og offentlig sektor.",
    url: "https://www.visma.no/",
    logo: vismaLogo,
    whiteLogo: vismaLogoWhite,
  },
};
